/**
 * Post Items Carousel Block
 */
import Swiper from "swiper";
import { A11y, Keyboard, Navigation } from "swiper/modules";
import { initializeOnApproach } from "../../../resources/js/_initialize-on-approach";

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".post-items-carousel");

  carousels.forEach((carousel) => {
    initializeOnApproach(carousel, () => initializePostItemsCarousel(carousel));
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".post-items-carousel")) {
    initializePostItemsCarousel(block);
  }

  block.querySelectorAll(".post-items-carousel").forEach((carousel) => {
    initializePostItemsCarousel(carousel);
  });
});

function initializePostItemsCarousel(carouselElement) {
  const railElement = carouselElement.querySelector(".post-items-carousel__rail");
  const swiperContainer = carouselElement.querySelector(
    ".post-items-carousel__swiper",
  );
  const prevButton = carouselElement.querySelector(
    ".post-items-carousel__button--prev",
  );
  const nextButton = carouselElement.querySelector(
    ".post-items-carousel__button--next",
  );

  if (
    !swiperContainer ||
    swiperContainer.dataset.postItemsCarouselInitialized === "true"
  ) {
    return;
  }

  const slides = swiperContainer.querySelectorAll(".swiper-slide");

  if (slides.length < 2) {
    carouselElement.classList.add("post-items-carousel--locked");
    return;
  }

  const updateRailWidth = () => {
    if (!railElement) {
      return;
    }

    const railBounds = railElement.getBoundingClientRect();
    const availableWidth = Math.max(0, window.innerWidth - railBounds.left);

    railElement.style.setProperty(
      "--post-items-carousel-visible-width",
      `${availableWidth}px`,
    );
  };

  updateRailWidth();
  swiperContainer.dataset.postItemsCarouselInitialized = "true";

  const syncLockState = (swiperInstance) => {
    carouselElement.classList.toggle(
      "post-items-carousel--locked",
      swiperInstance.isLocked,
    );
  };

  const swiper = new Swiper(swiperContainer, {
    modules: [A11y, Keyboard, Navigation],
    slidesPerView: 2.15,
    slidesOffsetBefore: 0,
    spaceBetween: 48,
    slidesOffsetAfter: 48,
    speed: 700,
    watchOverflow: true,
    allowTouchMove: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: "Previous posts",
      nextSlideMessage: "Next posts",
    },
    navigation:
      prevButton && nextButton
        ? {
            prevEl: prevButton,
            nextEl: nextButton,
          }
        : false,
    breakpoints: {
      0: {
        slidesPerView: 1.05,
        slidesOffsetBefore: 0,
        spaceBetween: 20,
        slidesOffsetAfter: 20,
      },
      768: {
        slidesPerView: 1.45,
        slidesOffsetBefore: 0,
        spaceBetween: 32,
        slidesOffsetAfter: 32,
      },
      992: {
        slidesPerView: 2.15,
        slidesOffsetBefore: 0,
        spaceBetween: 48,
        slidesOffsetAfter: 48,
      },
    },
    on: {
      init() {
        syncLockState(this);
      },
      resize() {
        syncLockState(this);
      },
      lock() {
        syncLockState(this);
      },
      unlock() {
        syncLockState(this);
      },
    },
  });

  requestAnimationFrame(() => {
    updateRailWidth();
    swiper.update();
    syncLockState(swiper);
  });

  window.addEventListener("resize", () => {
    updateRailWidth();
    swiper.update();
    syncLockState(swiper);
  });
}
